// import 'bootstrap';
// import 'mdbootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'mdbootstrap/css/mdb.min.css';
global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as faculty from '../libs/tech.faculty'
import * as shared from '../libs/tech.shared'
import { updateCoursePrices } from '../libs/tech.coursePrices'
import * as phone from '../libs/tech.phone'
import * as captchaV3 from '../libs/tech.captchaV3'

$(function () {
    updateCoursePrices();
    lazyLoad.initLazyLoad('.lazyBackground');
    lazyLoad.initLazyLoad('video.lazy');
})

//more imports here


export {core, lazyLoad, faculty, shared, phone, captchaV3}